// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"461":"207d4ce6","932":"917e0def"}[chunkId] + ".css";
};